import React from 'react';
import { AppBar, Toolbar } from '@mui/material';
import COLORS from '../../resources/style/Themes';

export const LoadingNavBar = () => {
  return (
    <AppBar
      position="fixed"
      sx={{ backgroundColor: COLORS.SAFEGUARD_BLUE, height: '65px' }}
    >
      <Toolbar />
    </AppBar>
  );
};

export default LoadingNavBar;
